import { createSelector } from 'reselect';

import { RootState } from 'app/store';

export const selectJobseekers = (state: RootState) =>
  state.jobseekers.jobseekers;

export const selectJobseekersDetails = (state: RootState) => {
  return state.jobseekers;
};

export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;

export const selectActiveJobseeker = createSelector(
  [selectJobseekers, selectActiveUserId],
  (jobseekers, activeUserId) =>
    jobseekers.find((jobseeker) => jobseeker.id === activeUserId)
);
